/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AppPage {
	Unknown = 'Unknown',
	Account = 'Account',
	Build = 'Build',
	Entries = 'Entries',
	Home = 'Home',
	Marketing = 'Marketing',
	Publish = 'Publish',
	Settings = 'Settings',
	Tasks = 'Tasks',
}
